import React from "react";
import { object, string } from "prop-types";
import { SvgIconHandler } from "../svg-icon-hadler";
import { getStoryLabel } from "../../utils/story";

import "./label.m.css";

export const Label = ({ story }) => {
  let label = getStoryLabel(story).toUpperCase();
  let labelClassName = "";
  switch (label) {
    case "LIVE":
      labelClassName = "live";
      break;
    case "BREAKING NEWS":
      labelClassName = "breaking-news";
      break;
    case "NEWS IN FOCUS":
      labelClassName = "news-in-focus";
      break;
    case "UPDATE":
      labelClassName = "update";
      break;
    case "GUIDE TO COOKING":
      labelClassName = "guide-to-cooking";
      break;
    case "PREMIUM":
      labelClassName = "premium";
      break;
    case "PARTNER CONTENT":
      labelClassName = "partner-content";
      break;
    default:
      labelClassName = "default-style";
  }
  return (
    <div styleName="headline-container">
      <div>
        {label && label === "PREMIUM" ? (
          <div styleName={labelClassName}>
            <SvgIconHandler type="premium" height="16px" width="16px" />
            <span>{label}</span>
          </div>
        ) : label === "LIVE" ? (
          <div styleName={labelClassName}>
            <span className="live-icon"></span>
            <span>{label}</span>
          </div>
        ) : (
          <div>
            <span styleName={labelClassName}>{label}</span>
          </div>
        )}
      </div>
    </div>
  );
};

Label.propTypes = {
  story: object,
  newStyle: string,
};
